import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
// import './utils/rem'
import { Timeline } from "ant-design-vue";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Timeline);
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
